import React from 'react';
import { createPortal } from 'react-dom';
import { ImproveModalBackdrop, ImproveModal } from '../styles';
import ImproveModalContent from './improveModalContent';

interface ImproveModalPortalProps {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  improvedText: string;
  modalRef: React.RefObject<HTMLDivElement>;
  onReplace: () => void;
}

const ImproveModalPortal: React.FC<ImproveModalPortalProps> = ({
  isOpen,
  onClose,
  isLoading,
  improvedText,
  modalRef,
  onReplace
}) => {
  if (!isOpen) return null;

  return createPortal(
    <ImproveModalBackdrop data-improve-modal onClick={onClose}>
      <ImproveModal ref={modalRef} loading={isLoading} onClick={(e: React.MouseEvent) => e.stopPropagation()}>
        <ImproveModalContent
          isImproveLoading={isLoading}
          improvedText={improvedText}
          onClickReplace={onReplace}
          onDismiss={(e?: React.MouseEvent) => {
            e?.stopPropagation();
            e?.preventDefault();
            onClose();
          }}
        />
      </ImproveModal>
    </ImproveModalBackdrop>,
    document.body
  );
};

export default ImproveModalPortal;
